import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-bar',
  imports: [CommonModule],
  templateUrl: './progressbar.component.html',
  styleUrl: './progressbar.component.scss'
})
export class ProgressbarComponent {
  @Input() totalOffset: number = 0;
  @Input() currentOffset: number = 0;

  get progressPercentage(): number {
    if (this.totalOffset === 0) return 0;
    return Math.min((this.currentOffset / this.totalOffset) * 100, 100);
  }
}
